<template>
  <div>
    <div style="padding-top:20px;">
      <div v-for="m in attForm.att_category_options" :key="m.value">
        <h4>{{m.label}}</h4>
        <template v-if="defaultList && defaultList[m.value]">
          <div class="demo-upload-list" v-for="(item, index) in defaultList[m.value]" :key="item.id">
            <template>
              <img class="myView" v-show="item.type === 'img'" :src="$store.state.common.baseURL + item.static_url +'?Authorization=' + token">
              <span class="myView" v-show="item.type === 'pdf'">{{item.att_name}}</span>
              <span class="myView">
                <Icon type="md-headset" />
                {{item.att_name}}
              </span>
              <div class="demo-upload-list-cover">
                <Icon type="ios-eye-outline" color="#19be6b" @click.native="handleView1(item)"></Icon>
                <Icon v-if="canEdit" color="#ed4014" type="ios-trash-outline" @click.native="delAtt1(item, index)"></Icon>
              </div>
            </template>
          </div>
        </template>
        <div v-if="!canEdit && defaultList && defaultList[m.value] && !defaultList[m.value].length" class="ivu-upload-drag" style="display: inline-block;">
          <div style="width: 58px;height:58px;line-height: 58px;">
            <Icon type="ios-camera" size="20"></Icon>
          </div>
        </div>
        <template v-if="canEdit">
          <div class="demo-upload-list" v-for="item in uploadList1[m.value]" :key="item.id">
            <template v-if="item.status === 'finished'">
              <img class="myView" v-show="item.type === 'img'" :src="$store.state.common.baseURL + item.response.StaticURL +'?Authorization=' + token">
              <span class="myView" v-show="item.type === 'pdf'">{{item.name}}</span>
              <span class="myView" v-show="item.type === 'mp4'">
                <Icon type="md-headset" />
                {{item.name}}
              </span>
              <div class="demo-upload-list-cover">
                <Icon type="ios-eye-outline" color="#19be6b" @click.native="handleView(item)"></Icon>
                <Icon type="ios-trash-outline" color="#ed4014" @click.native="delAtt(item)"></Icon>
              </div>
            </template>
            <template v-else>
              <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
            </template>
          </div>
          <Upload :ref="'upload'+m.value" :action="upLoadURL" :headers="headers" :data="{
            'src_id': attForm.src_id,
            'src_name': attForm.src_name,
            'att_category': m.value}" :show-upload-list="false" :on-success="uploaded" :format="accept" :max-size="51200" :before-upload="handleBeforeUpload" :on-error="doFailed"
            :on-format-error="handleFormatError" :on-exceeded-size="hanhdleMaxSize" multiple type="drag" style="display: inline-block;width:58px;">
            <div style="width: 58px;height:58px;line-height: 58px;">
              <Icon type="ios-camera" size="20"></Icon>
            </div>
          </Upload>
        </template>
      </div>
    </div>
    <Modal title="图片预览" v-model="visible">
      <img :src="img" v-if="visible" style="width: 100%">
      <div slot="footer"></div>
    </Modal>
  </div>
  </div>
</template>

<script type="text/ecmascript-6">
const COMP_NAME = 'DsAtt'
export default {
  name: COMP_NAME,
  props: {
    attForm: {
      type: Object,
      required: true
    },
    uploadList: {
      type: Object,
      required: true
    },
    defaultList: {
      type: Object
    }
  },
  computed: {
    canEdit: function () {
      if (this.attForm.show_mode === 'R') {
        return false
      } else {
        return true
      }
    }
  },
  watch: {
    uploadList (n) {
      this.uploadList1 = n
    }
  },
  data () {
    return {
      img: '',
      upLoadURL: this.$store.state.common.baseURL + this.$URLS.attUpload,
      headers: {
        'Authorization': this.$store.state.common.tokenPre + localStorage.getItem(this.$store.state.common.keyToken),
        'AppCode': window.sessionStorage.getItem(this.$store.state.common.AppCode),
        'MenuCode': this.attForm.menu_code
      },
      token: localStorage.getItem(this.$store.state.common.keyToken),
      accept: ['gif', 'jpg', 'jpeg', 'png', 'pdf', 'mp3', 'aac', 'wav', 'wma', 'cda', 'flac', 'm4a', 'mid', 'mka', 'mp2', 'mpa', 'mpc', 'ape', 'ofr', 'ogg', 'ra', 'wv', 'tta', 'ac3', 'dts', 'avi', 'asf', 'wmv', 'avs', 'flv', 'mkv', 'mov', '3gp', 'mp4', 'mpg', 'mpeg', 'dat', 'ogm', 'vob', 'rm', 'rmvb', 'ts', 'tp', 'ifo', 'nsv'],
      visible: false,
      uploadList1: this.uploadList
    }
  },
  methods: {
    handleBeforeUpload () {
      for (let i in this.uploadList) {
        this.uploadList1[i] = this.$refs['upload' + i][0].fileList
      }
    },
    handleFormatError (file) {
      this.$Notice.warning({
        title: file.name + '文件格式错误',
        desc: '当前仅支持pdf、音频文件、图片'
      })
    },
    // 音频文件上传过大
    hanhdleMaxSize (file) {
      this.$Notice.warning({
        title: file.name + '太大啦,不能超过50M'
      })
    },
    handleView (item) {
      if (item.type !== 'img') {
        this.showAtt(item.response.StaticURL)
        return
      }
      this.visible = true
      this.img = this.$store.state.common.baseURL + item.response.StaticURL + '?Authorization=' + this.token
    },
    uploaded (res, file, fileList) {
      if (!this.attForm.att_list) {
        this.attForm.att_list = []
      }
      this.attForm.att_list.push(res.obj)
      let name = file.name
      let type = this.$checkFilesType(name)
      this.uploadList1[res.AttCategory].forEach(m => {
        if (m.response.ID === res.ID) {
          m.type = type
        }
      })
    },
    doFailed (res, info) {
      this.$Message.error(info.message)
    },
    handleView1 (item) {
      if (item.type !== 'img') {
        this.showAtt(item.static_url)
        return
      }
      this.visible = true
      this.img = this.$store.state.common.baseURL + item.static_url + '?Authorization=' + this.token
    },
    showAtt (staticUrl) {
      let baseURL = this.$store.state.common.baseURL
      let str = localStorage.getItem(this.$store.state.common.keyToken)
      var url = baseURL + staticUrl + '?Authorization=' + str
      window.open(url)
    },
    delAtt (item) {
      let id = item.response.ID
      let att = item.response.AttCategory
      this.$setAuth(this.attForm.menu_code)
      this.$axios.post(this.$URLS.attDel, { id: id }).then(() => {
        this.attForm.att_list.forEach((m, index) => {
          if (m.id === id) {
            this.attForm.att_list.splice(index, 1)
            const fileList = this.$refs['upload' + att][0].fileList
            this.$refs['upload' + att][0].fileList.splice(fileList.indexOf(item), 1)
          }
        })
        // const fileList = this.$refs['upload' + att][0].fileList
        // this.$refs['upload' + att][0].fileList.splice(fileList.indexOf(item), 1)
      })
    },
    delAtt1 (item, index) {
      let id = item.id
      let att = item.att_category
      this.$setAuth(this.attForm.menu_code)
      this.$axios.post(this.$URLS.attDel, { id: id }).then(() => {
        this.attForm.att_list.forEach((m, index) => {
          if (m.id === id) {
            this.attForm.att_list.splice(index, 1)
          }
        })
      })
      this.defaultList[att].splice(index, 1)
    }
  },
  mounted () {
  }
}
</script>

<style type="text/stylus" lang="stylus" rel="stylesheet/stylus">
.demo-upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
}

.demo-upload-list .myView {
  width: 100%;
  height: 100%;
}

.demo-upload-list span.myView {
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display: inline-block;
  font-size: 12px;
}

.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}

.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}

.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  margin: 0 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/dsatt/DsAtt.vue